"use client"

import FilterRadioGroup from "@modules/common/components/filter-radio-group"
import { useT } from "@lib/i18n/client"

export type SortOptions = "price_asc" | "price_desc" | "created_at"

type SortProductsProps = {
  sortBy: SortOptions
  setQueryParams: (name: string, value: SortOptions) => void
  "data-testid"?: string
}

const SortProducts = ({
  "data-testid": dataTestId,
  sortBy,
  setQueryParams,
}: SortProductsProps) => {
  const t = useT()

  // Lista musi powstawać w komponencie, a nie w module: etykiety zależą
  // od języka, a ten znamy dopiero w czasie renderu.
  const sortOptions = [
    { value: "created_at", label: t("Najnowsze") },
    { value: "price_asc", label: t("Cena: od najniższej") },
    { value: "price_desc", label: t("Cena: od najwyższej") },
  ]

  const handleChange = (value: SortOptions) => {
    setQueryParams("sortBy", value)
  }

  return (
    <FilterRadioGroup
      title={t("Sortowanie")}
      items={sortOptions}
      value={sortBy}
      handleChange={handleChange}
      data-testid={dataTestId}
    />
  )
}

export default SortProducts
